<template>
  <!-- Callaction -->
   <section v-if="calltoaction !=''" class="section-call" :style="{backgroundImage: 'url(' + $imgURL + calltoaction[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
    <div class="base-info-call">
      <h1>{{ calltoaction[0].itiNome }}</h1>
        <div class="button-group-area mt-40">
					<p><router-link :to="calltoaction[0].itiLinkBtn1" class="btn hero-btn">{{ calltoaction[0].itiTextoBtn1 }}</router-link></p>
				</div>
    </div>
  </section>
  <!-- Callaction End -->
</template>

<script>
import axios from 'axios';

export default {
  name: 'PageCallAction',
  
  data: () => ({
    calltoaction: [],
    showModernizacaoMenu: false,
    return: {
      isMenuOpen: false
    }
  }),
  methods: {
    toggleModernizacaoMenu() {
      this.showModernizacaoMenu = !this.showModernizacaoMenu;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  },
  created() {
    //aqui busca call to action
    axios.get('/Process/InsInstitucional/institucional/58/callaction/0/x')
      .then(response => {
        this.calltoaction = response.data;
        //console.log('calltoaction')
        //console.log(this.calltoaction)
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>